import React from "react";

const Help = () => {

    return (
        <div>Help page</div>
    )
}

export default Help;